
export function cdescWrap() {
    var wrappers = document.querySelectorAll('.cdesc-wrap');
    if (wrappers.length > 0) {
        for (const wrapper of wrappers) {
            const content = wrapper.querySelector('.cdesc')
            const show = wrapper.querySelector('.show')
            const hide = wrapper.querySelector('.hide')
            show.classList.remove('disabled')
            show.onclick = (e) => {
                e.preventDefault()
                content.classList.remove('d-none')
                show.classList.add('d-none')
                hide.classList.remove('d-none')
            }
            hide.onclick = (e) => {
                e.preventDefault()
                content.classList.add('d-none')
                hide.classList.add('d-none')
                show.classList.remove('d-none')
            }
        }
    }
}
